<div class="gmb-status-profile-container">
  <div class="gmb-title">{{ 'csa.profile.gmb.about' | translate }}</div>
  <div class="status-container">
    <img class="gmb-logo" src="'./../../../../../assets/images/icons/gmb-logo.svg" alt="gmb-logo" />
    <div class="gmb-name">{{ 'csa.gmb' | translate }}</div>
    <div *ngIf="gmbStatus === gmbStages.STAGE5" class="active-state">{{ 'csa.profile.gmb.active' | translate }}</div>
    <div *ngIf="gmbStatus !== gmbStages.STAGE5" class="active-state">{{ 'csa.profile.gmb.inactive' | translate }}</div>
  </div>
  <div *ngIf="gmbStatus && gmbStatus !== gmbStages.STAGE5 && gmbStatus !== gmbStages.UNDEFINED && gmbStatus !== gmbStages.GIVEN_UP" class="gmb-state">
    {{ 'csa.profile.claiming.' + gmbStatus | translate }}
  </div>
  <div *ngIf="gmbStatus && gmbStatus === gmbStages.STAGE5" class="gmb-state">{{ 'csa.active.state.headline' | translate }}</div>
  <div *ngIf="gmbStatus && gmbStatus === gmbStages.GIVEN_UP" class="gmb-state">{{ 'csa.deactivated' | translate }}</div>

  <ng-container *ngIf="gmbStatus">
    <ng-container [ngSwitch]="gmbStatus">
      <div *ngSwitchCase="gmbStages.STAGE1" (click)="handleButtonClick()" class="claim-button primary-orange-button-bg">
        {{ 'csa.claiming.GMB_AWAITING_OWNERSHIP.title' | translate }}
      </div>
      <div *ngSwitchCase="gmbStages.STAGE2" (click)="handleButtonClick()" class="claim-button primary-orange-button-bg">
        {{ 'csa.claiming.premium.bottomsheet.interceptor.GMB_TOKEN_GIVEN.continue' | translate }}
      </div>
      <div *ngSwitchCase="gmbStages.STAGE4" (click)="handleButtonClick()" class="claim-button primary-orange-button-bg">
        {{ 'csa.claiming.premium.bottomsheet.interceptor.VERIFICATION_NEEDED.continue' | translate }}
      </div>
      <div *ngSwitchCase="gmbStages.STAGE5" (click)="viewListing()" class="claim-button primary-orange-button-bg">
        {{ 'csa.view-listing' | translate }}
      </div>
      <div *ngSwitchCase="gmbStages.GIVEN_UP" [routerLink]="['/main/dashboard']" class="claim-button primary-orange-button-bg">
        {{ 'csa.reactivate' | translate }}
      </div>
    </ng-container>
  </ng-container>
</div>
